export default __webpack_public_path__ + "static/media/admin_etiennethompson.4d9d691f.png";